<template>
    <div class="form-toolbar">
        <button v-if="cleared" class="swb-btn swb-btn-small fl mr10" @click="doCleared()">清理</button>
        <div v-if="!scrapped && !cleared">无操作</div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import assetVchrApi from '../../api/assetVchr'
    //
    export default {
        name: 'swb-asset-quick-option',
        desc: '资产快捷操作',
        props: {
            id: {
                type: Number,
                default: null
            },
            inStkAvQuantity: {
                type: Number,
                default: null
            },
            inStkNvQuantity: {
                type: Number,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            clearCause: {
                type: String,
                default: null
            },
            batchFlag: {
                type: Boolean,
                default: false
            },
            scrapped: {
                type: Boolean,
                default: false
            },
            cleared: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {}
        },
        created: function () {
        },
        methods: {
            // 清理
            doCleared: function () {
                if(Utils.isTrue(this.batchFlag)) {
                    this.doClear(this.id, this.clearCause, this.inStkAvQuantity, this.inStkNvQuantity);
                } else {
                    this.doShopDeviceSvcSubNoClear(this.id, this.clearCause);
                }
            },
            // 单品清理
            doShopDeviceSvcSubNoClear: function (id, clearCause) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "清理",
                    width: 580,
                    height: 400,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>是否自动审核</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-radio-group v-model="autoAudit">' +
                    '<el-radio :label="true">是</el-radio>' +
                    '<el-radio :label="false">否</el-radio>' +
                    '</el-radio-group>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>清理方式</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-select v-model="clearCause" clearable placeholder="请选择">' +
                    '<el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value">' +
                    '</el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>备注</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-input v-model="desc" type="textarea"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        devcClearCauseList: getEnumList("devcClearCause"),
                        clearCause: clearCause,
                        autoAudit: true,
                        desc: null,
                    },
                    okClicked: function () {
                        let dlgSelf = this;
                        self.$confirm('清理资产如果是在用将自动归还！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            let postData = {};
                            postData.id = id;
                            postData.clearCause = dlgSelf.clearCause;
                            let autoAudit = dlgSelf.autoAudit;
                            postData.autoAudit = autoAudit;
                            postData.desc = dlgSelf.desc;
                            let theLoad = MsgBox.loading();
                            assetVchrApi.doClearedShopDeviceSvcSubNo(postData, function (result) {
                                theLoad.hide();
                                if(result.type === "info") {
                                    theDlg.close();
                                    self.$emit("refreshChang", true);
                                    //
                                    let message = "清理已申请成功！";
                                    if(autoAudit) {
                                        message = "清理成功！";
                                    }
                                    self.scrapped = false;
                                    self.cleared = false;
                                    MsgBox.success(message);
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return false;
                        });
                    },
                    methods: {}
                });
            },
            // 批量清理
            doClear: function (id, clearCause, inStkAvQuantity, inStkNvQuantity) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "资产 - 清理",
                    width: 580,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div class="simple-form">' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>清理方式</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-select v-model="clearCause" clearable placeholder="请选择">' +
                    '<el-option v-for="item in devcClearCauseList" :key="item.value" :label="item.text" :value="item.value">' +
                    '</el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label class="required">清理数量</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-input v-model="quantity"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-group center">' +
                    '<div class="form-label">' +
                    '<label>含报废/弃用数量</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-input v-model="quantity2"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        devcClearCauseList: getEnumList("devcClearCause"),
                        clearCause: clearCause,
                        quantity2: null,
                        quantity: null
                    },
                    okClicked: function () {
                        if(Utils.isNoB(this.quantity)) {
                            Toast.show("清理数量不能为空！");
                            return false;
                        } else {
                            if(!Utils.isNaturalStr(this.quantity) || this.quantity <= 0) {
                                Toast.show("清理数量为大于零的整数！");
                                return false;
                            } else {
                                if(parseInt(this.quantity) > inStkAvQuantity) {
                                    Toast.show("清理数量不能大于在库数量.");
                                    return false;
                                }
                            }
                        }
                        if(!Utils.isNoB(this.quantity2)) {
                            if(!Utils.isNaturalStr(this.quantity2) || this.quantity2 <= 0) {
                                Toast.show("含报废/弃用数量为大于零的整数！");
                                return false;
                            } else {
                                let diffQuantity = parseInt(this.quantity) - parseInt(this.quantity2);
                                if(parseInt(this.quantity2) > inStkNvQuantity) {
                                    Toast.show("含报废数, 大于报废/弃用数量");
                                    return false;
                                }
                                if(diffQuantity > inStkAvQuantity || diffQuantity < 0) {
                                    Toast.show("清理的数量大于可清理的数量");
                                    return;
                                }
                            }
                        } else {
                            this.quantity2 = null;
                        }
                        let postData = {};
                        postData.id = id;
                        postData.clearCause = this.clearCause;
                        postData.quantity2 = this.quantity2;
                        postData.quantity = this.quantity;

                        let theLoad = MsgBox.loading();
                        assetVchrApi.doClearShopDeviceBatchStock(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                self.scrapped = false;
                                self.cleared = false;
                                //
                                MsgBox.success("清理成功！");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    },
                    methods: {}
                });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/AssetQuickOption.vue